//SelectRecordDialog
//***********************************************************************************************************************
import { Box, Grid, Typography } from "@mui/material";
import * as React from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { infiniteListPageSize } from "../../../models/common/webConsts";
import { IRecordListItem } from "../../../models/record/recordListItem";
import * as recordService from "../../../models/services/recordService";
import { ActionContainer } from "../../framework/ActionContainer";
import { Dialog } from "../../framework/Dialog/Dialog";
import { GridRow } from "../../framework/Grid/GridRow";
import { List } from "../../framework/List/List";
import { ListActionButtons } from "../../framework/List/ListActionButtons";
import { ListSearchFilter } from "../../framework/List/ListSearchFilter";
import { PageNavMenuItemCheckBox } from "../../framework/PageNavMenuItem/PageNavMenuItemCheckBox";
import { PageNavMenuItemRadio } from "../../framework/PageNavMenuItem/PageNavMenuItemRadio";
import { PageNavMenuItemTreeCheckBox } from "../../framework/PageNavMenuItem/PageNavMenuItemTreeCheckBox";
import { RecordPageList } from "../RecordPage/RecordPageList/RecordPageList";
import { RecordListFirstColumn } from "../RecordList/RecordListFirstColumn";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";
import { getRecordActivityFilters, RecordPageListActivityFilterId } from "../RecordPage/RecordPageList/RecordPageListUtils";

//SelectRecordDialog

/* eslint-disable no-unused-vars */
export const enum SelectRecordDialogMenuItem {
    None = "",
    ActivityFilter = "1",
    UnitFilter = "2",
    EmployeeTypeFilter = "3",
    JobTitleFilter = "4",
}
/* eslint-enable no-unused-vars */

export interface ISelectRecordDialogProps {
    classes?: string;
    companyId: string;
    multiSelect?: boolean;
    title?: string;
    requireSheetType?: boolean;
    units: IIdTitleNode[];
    jobTitles: IIdTitle[];
    canSelectOnlyOneCompanyRecords?: boolean;
    onOk: (companyId: string, users: IRecordListItem[]) => void;
    onCancel: () => void;
}

export interface ISelectRecordDialogState {
    //Menu
    filtersVisible: boolean;
    activityFilters: IIdTitle[];
    employeeTypes: IIdTitle[];
    activeMenuItem: SelectRecordDialogMenuItem;
    activeActivityFilterId: string;
    selectedUnitIds: string[];
    selectedJobTitleIds: string[];
    selectedEmployeeTypeIds: string[];

    //List
    intialized: boolean;
    isLoading: boolean;
    pageSize: number;
    page: number;
    hasMore: boolean;
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    items: IRecordListItem[];
    selectedId: string;
    checkedIds: string[];
    selectedCompanyId: string;
}

export class SelectRecordDialog extends React.Component<ISelectRecordDialogProps, ISelectRecordDialogState> {
    constructor(props: ISelectRecordDialogProps) {
        super(props);
        this.state = {
            //Menu
            filtersVisible: false,
            activityFilters: getRecordActivityFilters(false),
            employeeTypes: RecordPageList.getEmployeeTypes(),
            activeMenuItem: SelectRecordDialogMenuItem.ActivityFilter,
            activeActivityFilterId: RecordPageListActivityFilterId.Active,
            selectedUnitIds: [Base.emptyGuid],
            selectedJobTitleIds: [""],
            selectedEmployeeTypeIds: [""],
            //List
            intialized: false,
            isLoading: false,
            pageSize: 10000,
            page: 1,
            hasMore: true,
            filter: "",
            sortColumn: "lastName",
            sortOrderIsAsc: true,
            items: [],
            selectedId: null,
            checkedIds: [],
            selectedCompanyId: props.companyId,
        };
    }

    handleToggleActiveMenuItem = (menuItem: SelectRecordDialogMenuItem) => {
        this.setState({ activeMenuItem: this.state.activeMenuItem !== menuItem ? menuItem : SelectRecordDialogMenuItem.None });
    };

    searchItems = async (pageSize: number, page: number, filter: string, activityFilterId: string, selectedUnitIds: string[], selectedEmployeeTypeIds: string[],
        selectedJobTitleIds: string[], sortColumn: string, sortOrderIsAsc: boolean, resetItems: boolean, refreshList: boolean) => {
        const props = this.props;
        const state = this.state;
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => recordService.getRecordListItems(props.companyId, !refreshList ? pageSize : (page * infiniteListPageSize), !refreshList ? page : 1, filter,
            selectedEmployeeTypeIds.filter(i => !!i).map(i => i.toInteger()), selectedJobTitleIds.filter(i => !!i), selectedUnitIds.filter(i => i !== Base.emptyGuid),
            activityFilterId ? parseInt(activityFilterId, 10) : 0, sortColumn, sortOrderIsAsc, props.requireSheetType), false, false, () => this.setState({ isLoading: false }));
        if (!result) return;
        result.initializeQualifications();
        const items = List.getListItems(state.items, state.selectedId, state.checkedIds, result.items, resetItems, refreshList);
        this.setState({
            intialized: true,
            page: !refreshList ? result.page : page,
            hasMore: result.hasMore,
            filter,
            activeActivityFilterId: activityFilterId,
            selectedEmployeeTypeIds,
            selectedJobTitleIds,
            selectedUnitIds,
            sortColumn,
            sortOrderIsAsc,
            items: items.items,
            selectedId: items.selectedId,
            checkedIds: items.checkedIds,
        });
    };

    componentDidMount(): void {
        const state = this.state;
        this.searchItems(state.pageSize, 1, state.filter, state.activeActivityFilterId, state.selectedUnitIds, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, state.sortColumn, state.sortOrderIsAsc, true, false);
    }

    componentDidUpdate(prevProps: ISelectRecordDialogProps, prevState: ISelectRecordDialogState) {
        const props = this.props;
        const state = this.state;
        const prevCompanyId = prevProps.companyId ? prevProps.companyId : "";
        const companyId = props.companyId ? props.companyId : "";
        if (companyId === prevCompanyId) return;
        this.searchItems(state.pageSize, 1, state.filter, state.activeActivityFilterId, state.selectedUnitIds, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, state.sortColumn, state.sortOrderIsAsc, true, false);
    }

    changeFilter = (filter: string) => {
        const state = this.state;
        this.searchItems(state.pageSize, 1, filter, state.activeActivityFilterId, state.selectedUnitIds, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    changeaActivityFilter = (activityFilterId: string) => {
        const state = this.state;
        this.searchItems(state.pageSize, 1, state.filter, activityFilterId, state.selectedUnitIds, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    changeUnits = (selectedUnitIds: string[]) => {
        const state = this.state;
        this.searchItems(state.pageSize, 1, state.filter, state.activeActivityFilterId, selectedUnitIds, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    handleToggleEmployeeType = (employeeType: string, checked: boolean) => {
        const state = this.state;
        this.searchItems(state.pageSize, 1, state.filter, state.activeActivityFilterId, state.selectedUnitIds, Base.getToggledMultiSelectIds(state.employeeTypes, state.selectedEmployeeTypeIds, employeeType, checked),
            state.selectedJobTitleIds, state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    handleToggleJobTitle = (jobTitle: string, checked: boolean) => {
        const props = this.props;
        const state = this.state;
        this.searchItems(state.pageSize, 1, state.filter, state.activeActivityFilterId, state.selectedUnitIds, state.selectedEmployeeTypeIds, Base.getToggledMultiSelectIds(props.jobTitles, state.selectedJobTitleIds, jobTitle, checked),
            state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    handleSearchLines = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
        const state = this.state;
        this.searchItems(state.pageSize, !nextPage ? 1 : state.page + 1, state.filter, state.activeActivityFilterId, state.selectedUnitIds, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, sortColumn, sortOrderIsAsc, !nextPage, false);
    };

    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        const state = this.state;
        let selectedCompanyId = state.selectedCompanyId;
        if (this.props.canSelectOnlyOneCompanyRecords) {
            if (checkedIds.length === state.items.length) {
                //Check all (header checkbox)
                selectedCompanyId = state.items.length > 0
                    ? state.items[0].userCompanyId
                    : this.props.companyId;
                checkedIds = state.items.filter(i => i.userCompanyId === selectedCompanyId).map(i => i.id);
            } else {
                //Check some
                const newIds = List.getSelectedIds(selectedId, checkedIds);
                if (newIds.length > 0) {
                    const newUserCompanyIds = Base.getUniqueStringItems(state.items.filter(i => newIds.indexOf(i.id) > -1).map(i => i.userCompanyId));
                    if (newUserCompanyIds.length > 1) return;
                    selectedCompanyId = newUserCompanyIds[0];
                } else {
                    selectedCompanyId = this.props.companyId;
                }
            }
        }
        this.setState({
            selectedId,
            checkedIds,
            selectedCompanyId
        });
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    handleToggleFiltersVisible = () => {
        this.setState({
            filtersVisible: !this.state.filtersVisible,
        });
    };

    handleOk = () => {
        const state = this.state;
        const ids = List.getSelectedIds(state.selectedId, state.checkedIds);
        if (ids.length < 1) return;
        const items = state.items.filter(i => ids.indexOf(i.id) > -1);
        if (items.length < 1) return;
        this.props.onOk(state.selectedCompanyId, items);
    };

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.intialized) return null;
        return (
            <Dialog
                id="select-record-dialog"
                maxWidth="lg"
                maxHeight="90%"
                hide={!state.intialized}
                title={props.title ? props.title : Translations.SelectRecordUsers}
                body={
                    <GridRow sx={{ height: "calc(100% + 16px)", overflow: "hidden" }}>
                        <Grid
                            item
                            sm={state.filtersVisible ? 9 : 12}
                            sx={{ height: "100%" }}
                        >
                            <VerticalContainer
                                before={
                                    <ActionContainer
                                        leftItems={
                                            <ListSearchFilter
                                                searchFilter={state.filter}
                                                onSearchClick={this.changeFilter} />
                                        }
                                        rightItems={
                                            <ListActionButtons
                                                onFilter={this.handleToggleFiltersVisible}
                                            />
                                        }
                                    />
                                }
                                main={
                                    <List
                                        multiSelect={props.multiSelect}
                                        intialized={state.intialized}
                                        isLoading={state.isLoading}
                                        hasMore={state.hasMore}
                                        height="100%"
                                        header={{
                                            columns: [
                                                { size: 4, column: "unit", content: Translations.Unit },
                                                { size: 4, column: "lastName", content: Translations.LastName },
                                                { size: 4, column: "firstName", content: Translations.FirstName }
                                            ]
                                        }}
                                        lines={
                                            state.items.map((item) => {
                                                return {
                                                    columns: [
                                                        {
                                                            size: 4,
                                                            content: <RecordListFirstColumn item={item} title={item.unitCode} />
                                                        },
                                                        {
                                                            size: 4,
                                                            content:
                                                                <Box display="flex" alignItems="center">
                                                                    <AvatarImage
                                                                        id={item.userCode}
                                                                        name={item.getName()}
                                                                        image={item.picture}
                                                                        tooltip={item.getName()}
                                                                        marginRight=".5rem"
                                                                    />
                                                                    <Typography>{item.lastName}</Typography>
                                                                </Box>
                                                        },
                                                        { size: 4, content: item.firstName },
                                                    ],
                                                    id: item.id,
                                                    unselectable: this.props.canSelectOnlyOneCompanyRecords && state.checkedIds.length && item.userCompanyId !== state.selectedCompanyId,
                                                    classes: item.archived ? "disabled" : "",
                                                };
                                            })
                                        }
                                        sortColumn={state.sortColumn}
                                        sortOrderIsAsc={state.sortOrderIsAsc}
                                        selectedId={state.selectedId}
                                        checkedIds={state.checkedIds}
                                        onSetSelectedIds={this.handleSetSelectedIds}
                                        onSearchLines={this.handleSearchLines}
                                    />
                                }
                            />
                        </Grid>
                        <Grid
                            item
                            sm={state.filtersVisible ? 3 : 0}
                            sx={{
                                display: state.filtersVisible ? "block" : "none",
                                height: "100%",
                                overflowY: "auto",
                                paddingTop: "0px!important",
                                marginTop: "16px",
                                paddingRight: "1px;"
                            }}>
                            <PageNavMenuItemRadio
                                isActive={state.activeMenuItem === SelectRecordDialogMenuItem.ActivityFilter}
                                items={state.activityFilters}
                                activeItemId={state.activeActivityFilterId}
                                title={Translations.UserRecords}
                                onToggleMenuItem={() => this.handleToggleActiveMenuItem(SelectRecordDialogMenuItem.ActivityFilter)}
                                onSetActiveItem={(itemId: string) => this.changeaActivityFilter(itemId)}
                            />
                            <PageNavMenuItemTreeCheckBox
                                isActive={state.activeMenuItem === SelectRecordDialogMenuItem.UnitFilter}
                                items={props.units}
                                activeItemIds={state.selectedUnitIds}
                                title={Translations.Unit}
                                onToggleMenuItem={() => this.handleToggleActiveMenuItem(SelectRecordDialogMenuItem.UnitFilter)}
                                onSetActiveItemIds={(ids: string[]) => this.changeUnits(ids)}
                            />
                            <PageNavMenuItemCheckBox
                                isActive={state.activeMenuItem === SelectRecordDialogMenuItem.EmployeeTypeFilter}
                                items={state.employeeTypes}
                                activeItemIds={state.selectedEmployeeTypeIds}
                                title={Translations.EmployeeType}
                                onToggleMenuItem={() => this.handleToggleActiveMenuItem(SelectRecordDialogMenuItem.EmployeeTypeFilter)}
                                onSetActiveItem={this.handleToggleEmployeeType}
                            />
                            <PageNavMenuItemCheckBox
                                isActive={state.activeMenuItem === SelectRecordDialogMenuItem.JobTitleFilter}
                                items={props.jobTitles}
                                activeItemIds={state.selectedJobTitleIds}
                                title={Translations.JobTitle}
                                onToggleMenuItem={() => this.handleToggleActiveMenuItem(SelectRecordDialogMenuItem.JobTitleFilter)}
                                onSetActiveItem={this.handleToggleJobTitle}
                            />
                        </Grid>
                    </GridRow>
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.Next, variant: "confirmation", onClick: this.handleOk },
                ]}
                onClose={this.handleCancel}
            />
        );
    }
}